import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'

import style from '@src/pages/MyPoints/MyPoints.module.scss'
import { AppDispatch } from '@src/store/store'
import { selectProfile } from '@src/store/ducks/user/selectors'
import { getPoints, getProfile } from '@src/store/ducks/user/thunks'
import { selectIsLoading } from '@src/store/ducks/auth/selectors'
import { Preloader } from '@src/components/common/Preloader/Preloader'
// @ts-ignore
import Barcode from 'react-barcode'

export const MyPoints = () => {
  const dispatch = useDispatch<AppDispatch>()
  // const myPoints = useSelector(selectUserPoints)
  const myProfile = useSelector(selectProfile)
  const isLoading = useSelector(selectIsLoading)

  useEffect(() => {
    dispatch(getPoints())
    dispatch(getProfile())
  }, [dispatch])

  return (
    <div>
      <Preloader center loading={isLoading}>
        {/* <div className={style.pointsBlock}>
          <div className={style.pointsBlock_left}>
            <div className={style.title}>
              Накопленные баллы
            </div>
            <div className={style.container}>
              {myPoints.balanceInactive}
            </div>
            <div className={style.hint}>Доступны к списанию в следующем месяце</div>
          </div>
          <div className={style.pointsBlock_right}>
            <div className={style.title}>
              Доступные баллы
            </div>
            <div className={style.container}>
              {myPoints.bonuses}
            </div>
          </div>
        </div> */}
        <div className={style.cardBlock}>
          <div className={style.title}>Ваша карта лояльности</div>
          {myProfile.cardNumber?.map((el: any) => (
            <div className={style.cardBlock_container} key={el.number}>
              <div className={style.imageBlock}>
                <img src="/frontend/svg/static/cardImage.svg" className={style.image} alt="loyalty card" />
                <span>{el.number}</span>
              </div>
              <div className={style.barCode}>
                <Barcode height={123} id={`barcodes${el.number}`} key={el.number} value={el.number} />
              </div>
            </div>
          ))}
        </div>
      </Preloader>
    </div>
  )
}
